// Vite fills this in. Outside Vite, in a test that renders a component, it is simply absent,
// and an empty object is a better answer than a crash on the first property read.
const env = import.meta.env ?? ({} as ImportMetaEnv);

export const config = {
  apiUrl: (env.VITE_API_URL ?? '').replace(/\/+$/, ''),
  supabaseUrl: env.VITE_SUPABASE_URL ?? '',
  supabaseKey: env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '',
};

/** Names of required settings that are missing, so the app can say so instead of showing a blank window. */
export function missingConfig(): string[] {
  const required: [string, string][] = [
    ['VITE_API_URL', config.apiUrl],
    ['VITE_SUPABASE_URL', config.supabaseUrl],
    ['VITE_SUPABASE_PUBLISHABLE_KEY', config.supabaseKey],
  ];
  return required.filter(([, value]) => !value).map(([name]) => name);
}
